import {createContext} from 'react'

export const AppGuestContext = createContext({
    loginedFlg: false,
    updateLoginedFlg: (_updateLoginedFlg: boolean) => {
    },
})
